module.exports = __webpack_public_path__ + "static/Fantuan-dcf614cc11f460bbcd7b275dac42ade1.jpg";